export interface NavigateOptionExtensions {
  preventAutofocus?: boolean
  reloadDocument?: boolean
  preventTurbo?: boolean
}

export const PREVENT_AUTOFOCUS_KEY = '__gh__react-core-preventAutofocus'
